var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { fetchConsultar, fetchConsultarPaginada, fetchCadastrar, fetchAlterar } from '../../../api';
export { STATUS_API } from '../../../api';
var ROTA_SELECAO_PROFISSIONAIS = 'selecao-profissionais';
export var getOfertasVagasTrabalhos = function (TextoBusca, StatusOferta, Instituicao, PerfilLaboral, DataInicio, DataFim, TipoRegime, PaginationModel) { return __awaiter(void 0, void 0, void 0, function () {
    var Query, URL;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                Query = '';
                if (TextoBusca)
                    Query += "query=".concat(encodeURIComponent(TextoBusca), "&");
                if (StatusOferta)
                    Query += "status_ofertas=".concat(encodeURIComponent(StatusOferta), "&");
                if (Instituicao)
                    Query += "instituicao=".concat(Instituicao, "&");
                if (PerfilLaboral)
                    Query += "perfil_laboral=".concat(PerfilLaboral, "&");
                if (DataInicio)
                    Query += "data_inicio=".concat(encodeURIComponent(DataInicio), "&");
                if (DataFim)
                    Query += "data_fim=".concat(encodeURIComponent(DataFim), "&");
                if (TipoRegime)
                    Query += "tipo_regime=".concat(TipoRegime, "&");
                URL = "".concat(ROTA_SELECAO_PROFISSIONAIS, "?").concat(Query);
                return [4 /*yield*/, fetchConsultarPaginada(URL, PaginationModel)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var getVagas = function (TextoBusca, StatusVagas, Instituicao, PerfilLaboral, DataInicio, DataFim, PaginationModel) { return __awaiter(void 0, void 0, void 0, function () {
    var Query, URL;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                Query = '';
                if (TextoBusca)
                    Query += "query=".concat(encodeURIComponent(TextoBusca), "&");
                if (StatusVagas)
                    Query += "status_vagas=".concat(encodeURIComponent(StatusVagas), "&");
                if (Instituicao)
                    Query += "instituicao=".concat(Instituicao, "&");
                if (PerfilLaboral)
                    Query += "perfil_laboral=".concat(PerfilLaboral, "&");
                if (DataInicio)
                    Query += "data_inicio=".concat(encodeURIComponent(DataInicio), "&");
                if (DataFim)
                    Query += "data_fim=".concat(encodeURIComponent(DataFim), "&");
                URL = "".concat(ROTA_SELECAO_PROFISSIONAIS, "/vagas/?").concat(Query);
                return [4 /*yield*/, fetchConsultarPaginada(URL, PaginationModel)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var getOfertaVagaTrabalho = function (ID) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchConsultar("".concat(ROTA_SELECAO_PROFISSIONAIS, "/").concat(ID))];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var getCombosOfertasVagas = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchConsultar("".concat(ROTA_SELECAO_PROFISSIONAIS, "/combos"))];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var getCombosListarOfertasVagas = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchConsultar("".concat(ROTA_SELECAO_PROFISSIONAIS, "/combos-listar"))];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var getCombosListarVagas = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchConsultar("".concat(ROTA_SELECAO_PROFISSIONAIS, "/combos-listar-vagas"))];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var getCombosCadastrarVagas = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchConsultar("".concat(ROTA_SELECAO_PROFISSIONAIS, "/combos-vagas"))];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var cadastrarOfertaVagaTrabalho = function (Dados) { return __awaiter(void 0, void 0, void 0, function () {
    var URL;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                URL = "".concat(ROTA_SELECAO_PROFISSIONAIS);
                return [4 /*yield*/, fetchCadastrar(URL, Dados)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
//vagas
export var getVagasOferta = function (OfertaID, TipoRegime) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchConsultar("".concat(ROTA_SELECAO_PROFISSIONAIS, "/").concat(OfertaID, "/vagas").concat(TipoRegime ? "?tipo_regime=".concat(TipoRegime) : ''))];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var encerrarVagas = function (ArrayVagas, ObservacaoFinalizacao) { return __awaiter(void 0, void 0, void 0, function () {
    var URL;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                URL = "".concat(ROTA_SELECAO_PROFISSIONAIS, "/vagas/encerrar");
                return [4 /*yield*/, fetchAlterar(URL, { vagas: ArrayVagas, observacao_finalizacao: ObservacaoFinalizacao })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
